// src/MyRouter.jsx
import React, { Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import routesConfig from "./router";
import KeepAliveLayout from "./KeepAliveLayout";

const MyRouter = ({ myTokenVal, myLangGet, setMyLangGet }) => {
  const routes = routesConfig(myTokenVal, myLangGet, setMyLangGet);

  return (
    <Suspense>
      <Routes>
        <Route path="/" element={<KeepAliveLayout />}>
          <Route index element={<Navigate to="/home" replace />} />
          {routes.map((route, index) => {
            if (route.path === "*") {
              return <Route key={index} path="*" element={route.element} />;
            }
            const childPath = route.path.replace(/^\//, "");
            return <Route key={index} path={childPath} element={route.element} />;
          })}
        </Route>
      </Routes>
    </Suspense>
  );
};

export default MyRouter;
